import React, { useEffect, useState } from "react";
import { Marketplace } from "../../../../../server/routes/marketplace/types";
import SelectField from "../../../components/SelectField";
import getToken from "../../../getters/getToken";
import useRejectWithMessage from "../../../hooks/useRejectWithMessage";
import { getMarketplaceList } from "../../../requests";
import useFilterValue from "../Provider/hooks/useFilterValue";
import { FieldMarketplaceFC } from "./types";

const FieldMarketplace: FieldMarketplaceFC = () => {
  const { value, update } = useFilterValue("marketplace");
  const [marketplaces, updateMarketplaces] = useState<Marketplace[]>([]);
  const [isLoading, updateLoadgingStatus] = useState<boolean>(false);
  const token = getToken();
  const handlerReject = useRejectWithMessage(
    "Ошибка загрузки списка маркетплейсов"
  );
  useEffect(() => {
    updateLoadgingStatus(true);
    getMarketplaceList(token, { onlyConnected: true })
      .then(({ list }) => {
        updateMarketplaces(Object.values(list));
      })
      .catch(handlerReject)
      .finally(() => {
        updateLoadgingStatus(false);
      });
  }, []);
  const handlerChange = (marketplace: string) => {
    update(
      marketplaces.find(({ type }) => marketplace === type)?.type ?? undefined
    );
  };
  return (
    <SelectField
      selectProps={{ disabled: isLoading }}
      size={"small"}
      onChange={handlerChange}
      items={marketplaces.map(({ type, name }) => ({
        label: name,
        value: type,
      }))}
      value={value}
      label={"Маркетплейс"}
    />
  );
};

export default FieldMarketplace;
